import React from 'react'
import styled from 'styled-components'
import 'chartjs-plugin-datalabels'
import get from 'lodash/get'
import MixedChart from './mixed-chart'
import SummaryTable from './summary-table'
import { FONTS } from '../../../constants'

class EfficiencySummary extends React.Component {
  render() {
    const header = get(this.props, 'header')
    const efficiencySummary = get(this.props, 'efficiencySummary')
    const widthLeft = get(this.props, 'widthLeft')
    return (
      <Wrapper>
        <Header>
          { header }
        </Header>
        <MixedChart
          idChart={ get(this.props, 'idChart') }
          efficiencySummary={ efficiencySummary }
          widthLeft={ widthLeft }
        />
        <SummaryTable
          efficiencySummary={ efficiencySummary }
          widthLeft={ widthLeft }
        />
      </Wrapper>

    )
  }
}

export default EfficiencySummary

const Header = styled.div`
  height: 50px;
  width: 100%;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  padding-left: 10px;
  align-items: center;
`
const Wrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: white;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/efficiency-summary.js